import { collection, doc, type CollectionReference, type DocumentReference } from 'firebase/firestore'
import { db } from '../firebase'
import type { UserDoc, FolderDoc, BoardDoc, BoardVersionDoc } from './schemas'

/**
 * Coleções Firestore. Todas com prefixo `mapa_mental_`.
 * Sem subcoleções — versões em coleção raiz com campo `boardId`.
 */
export const usersCol = collection(db, 'mapa_mental_users') as CollectionReference<UserDoc>
export const foldersCol = collection(db, 'mapa_mental_folders') as CollectionReference<FolderDoc>
export const boardsCol = collection(db, 'mapa_mental_boards') as CollectionReference<BoardDoc>
export const versionsCol = collection(db, 'mapa_mental_board_versions') as CollectionReference<BoardVersionDoc>

export const userRef = (uid: string) => doc(usersCol, uid) as DocumentReference<UserDoc>
export const folderRef = (id: string) => doc(foldersCol, id) as DocumentReference<FolderDoc>
export const boardRef = (id: string) => doc(boardsCol, id) as DocumentReference<BoardDoc>
export const versionRef = (id: string) => doc(versionsCol, id) as DocumentReference<BoardVersionDoc>
